"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDictionaries = exports.DictionariesContextProvider = exports.DictionariesContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _endpoints = require("./endpoints");
var _lazyContextProxy = require("./lazy-context-proxy");
var _ = require("./");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
var DictionariesContext = /*#__PURE__*/_react.default.createContext({});
exports.DictionariesContext = DictionariesContext;
var useDictionaries = function useDictionaries() {
  return (0, _react.useContext)(DictionariesContext);
};
exports.useDictionaries = useDictionaries;
var DictionariesContextProvider = function DictionariesContextProvider(_ref) {
  var children = _ref.children;
  var payersReq = (0, _.useRequest)((0, _endpoints.getPayers)(), {
    manual: true
  });
  var context = (0, _lazyContextProxy.lazyContextProxy)({
    payersReq: payersReq,
    payers: payersReq.data
  });
  return /*#__PURE__*/_react.default.createElement(DictionariesContext.Provider, {
    value: context
  }, children);
};
exports.DictionariesContextProvider = DictionariesContextProvider;